import { render, staticRenderFns } from "./commoditymodel.vue?vue&type=template&id=7176d9ea&scoped=true"
import script from "./commoditymodel.vue?vue&type=script&lang=js"
export * from "./commoditymodel.vue?vue&type=script&lang=js"
import style0 from "./commoditymodel.vue?vue&type=style&index=0&id=7176d9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7176d9ea",
  null
  
)

export default component.exports